// extracted by mini-css-extract-plugin
module.exports = {"button":"Waffle-button-3c0ge","container":"Waffle-container-1oVDe","row":"Waffle-row-XRCFY","square":"Waffle-square-zdy3S"};